import type { Article } from '@/pages/Article/hooks/useArticle';
import { useBodyParser } from '../hooks/useBodyParser';
import { Content, VideoContainer } from './styled';
import { Link } from '@simplywallst/ui-core/next';

interface Props {
  article: Article;
}

const Body = ({ article }: Props) => {
  const parsedBody = useBodyParser({ body: article.body });

  return (
    <Content>
      {article.videoURL && (
        <>
          <VideoContainer>
            <iframe
              width="540"
              height="315"
              src={`https://www.youtube.com/embed/${article.videoURL}?rel=0`}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </VideoContainer>
          <div className="mb-4">
            <Link
              href={`${location.pathname}/watch`}
              className="focus-outline inline-block py-1 text-sm decoration-1 underline-offset-2"
            >
              Watch in player
            </Link>
          </div>
        </>
      )}
      {parsedBody}
    </Content>
  );
};

export default Body;
